import {
  CheckCircleOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  CarOutlined,
  ShopOutlined,
  TruckOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Timeline, Spin } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Router from "../";

export const ShipmentTracking = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [trackingData, setTrackingData] = useState(null);

  const searchParams = new URLSearchParams(location.search);
  const campaignRecruitmentId = searchParams.get("campaign_recruitment_id");

  const fetchTrackingData = async (campaignRecruitmentId) => {
    setLoading(true);
    const data = await Router.Api.getTrackingNumber(campaignRecruitmentId);

    if (data.result) {
      setTrackingData(data.result);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTrackingData(campaignRecruitmentId);
  }, [campaignRecruitmentId]);

  const trackingDetails = trackingData?.tracking_details?.trackingDetails || [];

  const currentLevel = trackingData?.tracking_details?.level || 0;
  const timelineItems = [...trackingDetails].reverse();

  const statusSteps = [
    { icon: <InboxOutlined />, label: "상품인수", active: currentLevel === 1 },
    {
      icon: <TruckOutlined />,
      label: "상품이동중",
      active: currentLevel === 2 || currentLevel === 3,
    },
    { icon: <ShopOutlined />, label: "배송지도착", active: currentLevel === 4 },
    { icon: <CarOutlined />, label: "배송출발", active: currentLevel === 5 },
    {
      icon: <CheckCircleOutlined />,
      label: "배송완료",
      active: currentLevel === 6,
    },
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin indicator={<LoadingOutlined className="text-[24px]" spin />} />
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col overflow-y-auto">
      <header>
        <p className="text-[18px] flex justify-center items-center p-[15px] whitespace-nowrap">
          스마트택배 배송조회
        </p>
      </header>
      <div className="p-5 bg-[#03a9f4]">
        <div className="inline-block text-white text-[12px] border border-white px-[10px] py-1 rounded-[20px] mb-[10px]">
          운송장 번호
        </div>
        <div className="text-[24px] font-bold mb-[5px] text-white">
          {trackingData?.tracking_number || "-"}
        </div>
        <div className="text-[16px] text-white">
          {trackingData?.courier_company || "-"}
        </div>
      </div>

      <main className="flex-1">
        {/* 배송 상태 아이콘 */}
        <div className="flex items-center justify-center py-[30px] bg-white relative mb-[10px]">
          {statusSteps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col items-center relative flex-1 min-w-0 h-[50px]"
            >
              <div className="flex items-center w-full mb-2 relative">
                {/* 연결선 (아이콘 앞쪽, 첫 번째가 아닐 때만) */}
                {index > 0 && (
                  <div
                    className="absolute left-0 h-px bg-[#e0e0e0] z-[1]"
                    style={{ right: "calc(50% + 25px)" }}
                  />
                )}
                <div
                  className={`w-[50px] h-[50px] rounded-full flex items-center justify-center text-[20px] relative z-[2] mx-auto flex-shrink-0 ${
                    step.active
                      ? "bg-[#03a9f4] text-white"
                      : "bg-[#e0e0e0] text-[#666]"
                  }`}
                >
                  {step.icon}
                </div>
                {/* 연결선 (아이콘 뒤쪽, 마지막이 아닐 때만) */}
                {index < statusSteps.length - 1 && (
                  <div
                    className="absolute right-0 h-px bg-[#e0e0e0] z-[1]"
                    style={{ left: "calc(50% + 25px)" }}
                  />
                )}
              </div>
              <div
                className={`text-[12px] text-center ${
                  step.active
                    ? "text-[#03a9f4] font-bold"
                    : "text-[#666] font-normal"
                }`}
              >
                {step.label}
              </div>
            </div>
          ))}
        </div>

        {/* 상세 배송 타임라인 */}
        <div className="pt-[30px] px-5">
          {timelineItems.length > 0 ? (
            <Timeline>
              {timelineItems.map((item, idx) => (
                <Timeline.Item
                  key={idx}
                  color="#03a9f4"
                  style={
                    idx === timelineItems.length - 1
                      ? { paddingBottom: 0 }
                      : undefined
                  }
                >
                  <div
                    className={`text-[14px] ${
                      item.level === currentLevel
                        ? "font-bold text-[#03a9f4]"
                        : "font-normal text-[#333]"
                    }`}
                  >
                    {item.where} | {item.kind}
                  </div>
                  <div className="text-[12px] text-[#999]">
                    {item.timeString}
                  </div>
                </Timeline.Item>
              ))}
            </Timeline>
          ) : (
            <div className="p-5 text-center text-[#999] text-[14px] flex justify-center items-center min-h-[200px]">
              배송 준비 중
            </div>
          )}
        </div>
      </main>

      {/* 푸터 */}
      <div className="px-5 py-[15px] bg-[#f5f5f5] flex items-center text-[12px] text-[#666]">
        <InfoCircleOutlined className="text-[16px] text-[#03a9f4] mr-2" />
        배송 정보 제공: 스윗트래커 스마트택배API
      </div>
    </div>
  );
};
